import {
  Button,
  Card,
  ErrorCard,
  List,
  LoadingCard,
} from '@odmonorepo/core-components';
import { useState } from 'react';
import { Stack } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { rawProfileToList } from '../Transformers/rawProfileToList';
import PersonalForm from '../Components/OwnerForm';
import { usePersons } from 'merchant-api/spiceroad';

export const PersonalCard = ({ showEdit = false }: { showEdit?: boolean }) => {
  const [editing, setEditing] = useState(false);
  const { person, isError, isLoading } = usePersons();
  const intl = useIntl();

  if (isError)
    return (
      <ErrorCard name={intl.formatMessage({ id: 'loading.error.profile' })} />
    );
  if (isLoading) return <LoadingCard />;
  if (!person) return null;
  const profileList = rawProfileToList(person).listObj;

  const handleSubmit = () => {};

  return (
    <Card>
      <Stack direction="horizontal">
        <h4>Personal Details</h4>
        {showEdit && (
          <Button
            variant="link"
            className="ms-auto p-0"
            onClick={() => setEditing((e) => !e)}
          >
            {editing ? 'Cancel' : 'Edit'}
          </Button>
        )}
      </Stack>
      {editing ? (
        <PersonalForm onSubmit={() => handleSubmit()} />
      ) : (
        <List obj={profileList} />
      )}
    </Card>
  );
};

export default PersonalCard;
